import { render } from "./Competence.vue?vue&type=template&id=2907603b"
import script from "./Competence.vue?vue&type=script&lang=js"
export * from "./Competence.vue?vue&type=script&lang=js"

import "./Competence.vue?vue&type=style&index=0&id=2907603b&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__